export default __webpack_public_path__ + "static/media/Individual_leaderboard.05fac2f1.png";